import mixpanel from 'mixpanel-browser';
import {
  LOCAL_STORAGE_AUTH_TOKEN,
  LOCAL_STORAGE_USER_DATA,
  LOCAL_STORAGE_USER_FORMSTACK,
  LOCAL_STORAGE_USER_ID,
} from 'common/localStorageKeys';
import { IGetSkuDataByFormatReturn, IRecurrence } from './@types';

const RECURRENCES: { [x: string | number]: IRecurrence } = {
  w: {
    recurrence: 'weekly',
  },
  1: {
    recurrence: 'monthly',
  },
  3: {
    recurrence: 'quarterly',
  },
  6: {
    recurrence: 'semester',
  },
  12: {
    recurrence: 'yearly',
  },
  lifetime: {
    recurrence: 'lifetime',
  },
};

const renderIf = (
  condition: boolean,
  component: JSX.Element,
  alternativeComponent?: JSX.Element | null,
): JSX.Element | null => (condition ? component : alternativeComponent || null);

const getUserIdFromLocalStorage = (): string | null => window.localStorage.getItem(LOCAL_STORAGE_USER_ID);
const getAuthTokenFromLocalStorage = (): string | null => window.localStorage.getItem(LOCAL_STORAGE_AUTH_TOKEN);
const getUserFromLocalStorage = (): object => JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_AUTH_TOKEN) || '{}');
const setUserLocalStorage = (data: object): void =>
  window.localStorage.setItem(LOCAL_STORAGE_USER_DATA, JSON.stringify(data));
const clearSession = (): void | null => {
  window.localStorage.clear();
  mixpanel.reset();
};

const setIsFormstackUser = (value: boolean): void =>
  window.localStorage.setItem(LOCAL_STORAGE_USER_FORMSTACK, `${!!value}`);

const verifyIsFormstackUser = (): boolean =>
  /^true$/i.test(window.localStorage.getItem(LOCAL_STORAGE_USER_FORMSTACK) as string) || false;

const getSkuDataByFormat = (sku: string): IGetSkuDataByFormatReturn => {
  const separator = '_';
  const skuSplitted = `${sku}`.split(separator);
  const path = skuSplitted.slice(1).join(separator) || 'unknown';
  const recurrenceKey = +skuSplitted[2] || `${skuSplitted[2]}`.toLocaleLowerCase();
  const recurrence = RECURRENCES[recurrenceKey]?.recurrence || 'unknown';

  const dataByFormat = {
    skuSplitted,
    sku,
    path,
    recurrence,
  };
  return dataByFormat;
};

const getUrlPrams = (): { [x: string]: string | unknown } => {
  const params: { [x: string]: string | unknown } = {};

  if (window.location.search) {
    try {
      decodeURI(window.location.search)
        .replace('?', '')
        .split('&')
        .map((param) => param.split('='))
        .map((values) => {
          const [key, value] = values;
          params[key] = value;
          return values;
        }, {});
    } catch (error) {
      params.catchError = error;
    }
  }

  return params;
};

export {
  renderIf,
  getUserIdFromLocalStorage,
  getAuthTokenFromLocalStorage,
  clearSession,
  getUserFromLocalStorage,
  setUserLocalStorage,
  getSkuDataByFormat,
  getUrlPrams,
  verifyIsFormstackUser,
  setIsFormstackUser,
};
